import axios from 'axios';

// Get API base URL from environment variable
// In production, this will be set via Cloudflare Pages environment variables
// Format: https://oliebol-api.52bpxzdnzs.workers.dev
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

// Create axios instance with base URL
const apiClient = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		'Content-Type': 'application/json'
	}
});

export default apiClient;

